import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const taxonomiesManifest: FeatureManifest = {
  id: 'taxonomies',
  path: 'taxonomies/*',
  navPath: '/taxonomies',
  label: 'Phân loại',
  description: 'Quản lý hệ thống phân loại khoá học',
  load: () => import('./entry'),
}
